import { api } from '@/lib/api';
import type { IApiResponse, IIssueCurrent, IIssueCurrentListFilters, IIssueCurrentSummary } from '@skystone/shared';

export const issueCurrentApi = {
  getAll: async (filters?: IIssueCurrentListFilters): Promise<IIssueCurrent[]> => {
    const params = new URLSearchParams();
    if (filters?.productId) params.set('productId', filters.productId);
    if (filters?.teamId) params.set('teamId', filters.teamId);
    if (filters?.issueType) params.set('issueType', filters.issueType);
    if (filters?.status) params.set('status', filters.status);
    if (filters?.from) params.set('from', filters.from);
    if (filters?.to) params.set('to', filters.to);
    if (filters?.includeUnassigned !== undefined) params.set('includeUnassigned', String(filters.includeUnassigned));
    if (filters?.includeArchived !== undefined) params.set('includeArchived', String(filters.includeArchived));
    if (typeof filters?.limit === 'number') params.set('limit', String(filters.limit));
    if (typeof filters?.offset === 'number') params.set('offset', String(filters.offset));

    const query = params.toString();
    const url = query ? `/issue-current?${query}` : '/issue-current';
    const result = await api.get<IApiResponse<IIssueCurrent[]>>(url);
    return result.data;
  },

  getSummary: async (filters?: IIssueCurrentListFilters): Promise<IIssueCurrentSummary> => {
    const params = new URLSearchParams();
    if (filters?.productId) params.set('productId', filters.productId);
    if (filters?.teamId) params.set('teamId', filters.teamId);
    if (filters?.issueType) params.set('issueType', filters.issueType);
    if (filters?.status) params.set('status', filters.status);
    if (filters?.from) params.set('from', filters.from);
    if (filters?.to) params.set('to', filters.to);
    if (filters?.includeUnassigned !== undefined) params.set('includeUnassigned', String(filters.includeUnassigned));
    if (filters?.includeArchived !== undefined) params.set('includeArchived', String(filters.includeArchived));

    const query = params.toString();
    const url = query ? `/issue-current/summary?${query}` : '/issue-current/summary';
    const result = await api.get<IApiResponse<IIssueCurrentSummary>>(url);
    return result.data;
  },
};
